<template>
    <div class="CreateMultipleParticipantDiv">
        <div class="container-fluid">
            <div class="row vertical-align margin-Top-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2 width cursor-pointer">
                  <a :href="downloadCSVUrl" class="text-decoration-none">
                    <img src= "../assets/images/download.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="download">
                  </a>  
                </div>
                <div class="col-md-3 col-lg-3 text-align-left font-size-20px cursor-pointer">
                  <a :href="downloadCSVUrl" class="text-decoration-none">
                    Download CSV Template
                 </a>   
                </div>
                <div class="col-md-6 col-lg-6">
                </div>
            </div>
            <div class="row vertical-align margin-Top-2Perc">   
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-2 col-lg-2 width cursor-pointer">
                    <img src= "../assets/images/upload.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="upload" v-on:click="updateHideUploadCSVTemplateOverlayFlag($event,true)">
                </div>
                <div class="col-md-3 col-lg-3 text-align-left font-size-20px cursor-pointer" v-on:click="updateHideUploadCSVTemplateOverlayFlag($event,false)">
                    Upload CSV File
                </div>
                <div class="col-md-1 col-lg-1">
                </div>    
            </div>
            <!-- Create Lesson Overlay -->
            <div id="myNav" class="overlay overlay-overall-width-0Perc" v-bind:class="{'overlay-overall-width-100Perc': !uploadCSVTemplateOverlay}">
                <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
                    <div class="row">
                        <div class="col-md-12 col-lg-12">
                            <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="updateHideUploadCSVTemplateOverlayFlag($event,true)">
                                <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                            </div>  
                        </div>
                    </div>
                    <div class="row margin-top-1Perc margin-bottom-2Perc">
                        <div class="col-md-12 col-lg-12 font-weight-bold font-size-20px">
                            Upload CSV File
                        </div>    
                    </div>
                    <div class="row vertical-align">
                      <div class="col-md-1 col-lg-5 font-size-18px text-align-right width-43Point8Perc">
                        Group
                      </div> 
                      <div class="col-md-3 col-lg-3 padding-left-0px">
                        <select class="form-control Padding-right-0px" v-model="selectedGroupObj">
                          <option value=-1 disabled>Select</option>
                          <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                        </select>                  
                      </div>
                    </div>
                    <div class="row margin-top-3Perc">
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <input type="file" class="align-center" accept=".csv" id="uploadcsvfile">
                                </div>
                            </div>
                        </div>    
                    </div>
                    <div class="row margin-top-3Perc">
                        <div class="col-md-4 col-lg-4">
                        </div>    
                        <div class="col-md-2 col-lg-2">
                          <!-- ToDo: Track this -->
                            <button class="btn btn-primary btn-block upload-csv-overlay-button-BG black-font-color" @click="checkAndUploadCSV">Upload</button>
                        </div> 
                        <div class="col-md-2 col-lg-2">
                          <!-- ToDo: Track this -->
                            <button class="btn btn-primary btn-block" v-on:click="updateHideUploadCSVTemplateOverlayFlag($event,true)">Cancel</button>
                        </div> 
                        <div class="col-md-4 col-lg-4">
                        </div>       
                    </div>
                    <div class="row margin-Top-2Perc">
                        <div class="col-md-12 col-lg-12">
                        </div>    
                    </div>    
                </div>
            </div>      
        </div>
        <csv-upload-response-overlay v-if="showUploadCSVResponseOverlay" v-bind:selectedCohortObj="null" v-bind:responseObj="getUploadCSVResponse" @showCSVResponseOverlay="hideCSVResponseOverlay"></csv-upload-response-overlay>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
        </div>
        <loader></loader>      
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import AlertBox from '@/components/AlertOverlay'
import CSVUploadResponseOverlay from '@/components/CSVUploadResponseOverlay'
import { participantService } from '@/server-util/participant-service'
import { groupService } from '@/server-util/group-service'
export default {
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      uploadCSVTemplateOverlay: true,
      downloadCSVUrl: server.baseURL() + '/api/EnrollUser/DownloadUserCSVTemplate',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showUploadCSVResponseOverlay: false,
      uploadCSVResponse: [],
      selectedGroupObj: -1,
      groupList: []
    }
  },
  methods: {
    updateHideUploadCSVTemplateOverlayFlag: function (event, flagToUpdate) {
      // AK: Enable Disable background scrolling
      if (flagToUpdate === false) {
        this.$store.state.isOverlayVisible = true
      } else {
        this.selectedGroupObj = -1
        document.getElementById('uploadcsvfile').value = ''
        this.$store.state.isOverlayVisible = false
      }
      // AK: Show or hide overlay
      this.uploadCSVTemplateOverlay = flagToUpdate
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.groupList = storeObj.state.groupList
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              _this.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    checkAndUploadCSV: function () {
      var fileUrl = document.getElementById('uploadcsvfile').files[0]
      if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
      } else {
        if (fileUrl !== undefined) {
          if (!this.checkCSVFileExtesion(document.getElementById('uploadcsvfile').value)) {
            this.showAlertDialog = true
            this.errorMsg = 'Invalid file format detected.'
          } else {
            this.uploadCSVTemplate()
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a .csv file.'
        }
      }
    },
    checkCSVFileExtesion: function (fileName) {
      var exts = ['.csv', '.CSV']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    uploadCSVTemplate: function () {
      var storeObj = this.$store
      var _this = this
      var fileUrl = document.getElementById('uploadcsvfile').files[0]

      const formData = new FormData()
      formData.append('CSVFile', fileUrl)

      // _this.showSpinner = true
      this.$store.state.isLoading = true
      participantService
        .enrollMultipleParticipantUsingCSV(
          storeObj.state.access_token,
          '',
          this.selectedGroupObj.GroupId,
          formData
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            this.selectedGroupObj = -1
            document.getElementById('uploadcsvfile').value = ''
            // AK: Hide Spinner after recieving success response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Hide Upload CSV template overlay
            _this.uploadCSVTemplateOverlay = true
            _this.uploadCSVResponse = responseObj.data
            // AK: Show server response to user in overlay
            _this.showUploadCSVResponseOverlay = true
            // AK: Disable background scrolling
            _this.$store.state.isOverlayVisible = true
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    hideCSVResponseOverlay (value) {
      // AK: its is used to hide the Response overlay
      this.showUploadCSVResponseOverlay = value
      // AK: enable background scrolling
      this.$store.state.isOverlayVisible = value
    }
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.groupList
      }
    },
    getUploadCSVResponse: {
      get: function () {
        return this.uploadCSVResponse
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'csv-upload-response-overlay': CSVUploadResponseOverlay,
    'loader': Loader
  },
  name: 'CreateMultipleParticipantDiv'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.icon-width-height {
  width: 40px;
  height: 40px;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.upload-csv-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.text-decoration-none {
  text-decoration: none !important;
}
.font-size-18px {
  font-size: 18px;
}
.border-red{
  border: 1px solid red;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.padding-left-0px{
  padding-left:0px;
}
.padding-right-0px{
  padding-right:0px;
}
.width-13Perc{
  width: 13%;
}
.width-43Point8Perc{
  width:43.8%;
}
.margin-bottom-2Perc{
  margin-bottom: 2%;
}
</style>





// WEBPACK FOOTER //
// src/components/CreateMultipleParticipants.vue